import { ContentBlock } from 'draft-js';
import { findWithRegex } from '../../draft-js-utils/src';

import emojiRegexp from 'emoji-regex';

export const unicodeEmojiRegExp = emojiRegexp();

export default (contentBlock: ContentBlock, callback: StrategyCallback): void => {
  findWithRegex(unicodeEmojiRegExp, contentBlock, callback);
};
